import * as React from 'react';

function SvgSmallClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="m5.903 4.993 3.885-3.885a.646.646 0 1 0-.914-.914L4.99 4.079 1.104.194a.646.646 0 1 0-.914.914l3.885 3.885L.19 8.878a.646.646 0 1 0 .914.914l3.885-3.885 3.885 3.885a.645.645 0 0 0 .914 0 .646.646 0 0 0 0-.914L5.903 4.993z"
          id="8s5k9r6iua"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="6g57yaxeub" fill="#fff">
          <use xlinkHref="#8s5k9r6iua" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#8s5k9r6iua" />
        <path fill="#93969D" mask="url(#6g57yaxeub)" d="M0 0h10v10H0z" />
      </g>
    </svg>
  );
}

export default SvgSmallClose;
